import { apiRequest } from '@scc/lib'
import type { PlanCustomLineRepository } from '@/data/repositories/types'
import type { PlanCustomLine, PlanCustomLineInput } from '@/shared-client-safe/plan-custom-lines'

/** Custom lines live under the plan they belong to — same path, same guards. */
const base = (agencyId: number, storeId: number, projectionId: string) =>
  `/agencies/${agencyId}/stores/${storeId}/launch-projections/${projectionId}/custom-lines`

export function createApiPlanCustomLineRepository(): PlanCustomLineRepository {
  return {
    list: (agencyId, storeId, projectionId) =>
      apiRequest<PlanCustomLine[]>(base(agencyId, storeId, projectionId)),
    create: (agencyId, storeId, projectionId, input: PlanCustomLineInput) =>
      apiRequest<PlanCustomLine>(base(agencyId, storeId, projectionId), { method: 'POST', body: input }),
    update: (agencyId, storeId, projectionId, lineId, input: Partial<PlanCustomLineInput>) =>
      apiRequest<PlanCustomLine>(`${base(agencyId, storeId, projectionId)}/${lineId}`, { method: 'PUT', body: input }),
    remove: async (agencyId, storeId, projectionId, lineId) => {
      await apiRequest<void>(`${base(agencyId, storeId, projectionId)}/${lineId}`, { method: 'DELETE' })
    },
  }
}
